import axios from '@plugins/axios'
import getSecret from '@utils/get-secret'

let serverUrl = getSecret('SERVER_URL')


export const state = {
  cached: {},
}

export const getters = {}

export const mutations = {
  CACHE_USER(state, users) {
    state.cached = users
  },
}

export const actions = {

  init({ state, dispatch }) {},


  fetchUsers(context, query) {
    query = query || ''
    return axios.get(`${serverUrl}/users/${query}`).then((response) => {
      const users = response.data
      context.commit('CACHE_USER', users)
      return users
    })
  },
  
  fetchUsersForOptions(context, query) {
    query = query || ''
    return axios.get(`${serverUrl}/users/for_options/${query}`).then((response) => {
      return response.data
    })
  },
  
  fetchUsersDetail(context, url) {
    return axios.get(url).then((response) => {
      return response.data
    })
  },

  createUpdateUsers(context, formData) {
    let promise = null
    if (formData.url){
      promise =  axios.put(formData.url, formData)
    }else {
      promise =  axios.post(`${serverUrl}/users/`, formData)
    }
    return promise.then(
      (response) => {
        return response.data
      }
    )
  },

  deleteUsers(context, url) {
    let promise = null
    promise =  axios.delete(url)
    return promise.then(
      (response) => {
        return response.data
      }
    )
  },

  changePassword(context, formData) {
    let promise = null
    promise =  axios.put(`${formData.url}set_password/`, formData)
    return promise.then(
      (response) => {
        return response.data
      }
    )
  },
  updatePhotos(context, formData) {
      let promise = null
      promise =  axios.put(`${formData.get('url')}set_photo/`, formData, {
        headers: {'Content-Type': 'multipart/form-data'}
      })
      return promise.then(
        (response) => {
          return response.data
        }
      )
    },

  // This request is auto-authenticated by app user
  checkIfUserExists(context, username) {
    return axios.get(`${serverUrl}/users/exists/?search=${username}`, { 'appRequest': true }).then((response) => {
      return response.data
    })
  },

  registerUsers(context, formData) {
    // Used for user registration forms
    let promise = null
    if (formData.url){
      promise =  axios.put(formData.url, formData)
    }else {
      promise =  axios.post(`${serverUrl}/users/register/`, formData, { 'appRequest': true })
    }
    return promise.then(
      (response) => {
        return response.data
      }
    )
  }

}